module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qblw-box"
  }, [_c('div', {
    staticClass: "qblw-box-container"
  }, [_c('div', {
    staticClass: "qblw-box-top"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.quanbuliwu')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/image/tanchuang_x_b@2x.png"),
      "alt": "关闭"
    },
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qblw-box-fl"
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('div', {
      key: index,
      class: index === _vm.listIndex ? 'qblw-box-fl-item' : 'qblw-box-fl-item1',
      on: {
        "click": function($event) {
          return _vm.handleChooseCategory(index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.categoryName) + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "qblw-box-list",
    on: {
      "mouseleave": _vm.handleListMouseLeave
    }
  }, _vm._l((_vm.currentGiftList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.currentGiftIndex === index ? 'qblw-box-list-item' : 'qblw-box-list-item1',
      on: {
        "mouseenter": function($event) {
          return _vm.handleGiftMouseEnter(index, $event)
        }
      }
    }, [_c('img', {
      staticClass: "qblw-box-list-item-img",
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), (_vm.currentGiftIndex !== index) ? _c('div', {
      staticClass: "qblw-box-list-item-span"
    }, [_vm._v(_vm._s(item.giftName))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "qblw-box-list-item-span1"
    }, [_vm._v(_vm._s(item.price) + "US" + _vm._s(_vm.$t('all.bi')))]), _vm._v(" "), (_vm.currentGiftIndex === index) ? _c('div', {
      staticClass: "qblw-box-list-item-zs",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.giveGift()
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('all.zengsong')) + "\n        ")]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.showPopup) ? _c('popup', {
    attrs: {
      "show": _vm.showPopup,
      "x": _vm.popupPosition.x,
      "y": _vm.popupPosition.y
    },
    on: {
      "mouseenter": _vm.handlePopupMouseEnter,
      "mouseleave": _vm.handlePopupMouseLeave,
      "giveGif": _vm.handleGiveGif
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f786e61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quanbuliwu/quanbuliwu.vue
// module id = 958
// module chunks = 1